/* eslint-disable react/prop-types */
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Alert,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { useCallback, useContext, useEffect, useState } from "react";
import { formatCpfCnpj } from "../../../../../utils/cpfCnpjFormatter";
import { formatPhone } from "../../../../../utils/telefoneFormatter";
import EstadosECidades from "../../../../../data/estadosCidades";
import api from "../../../../../services/axiosConfig";
import Config from "../../../../../config/config";
import { toast } from "react-toastify";
import { copyToClipboard } from "@phntms/react-share";
import { limparCpfCnpj, limparTelefone } from "../../../../../utils/clearMasks";
import { Context } from "../../../../../hooks/useAuthContext";
import { generateCodeUtm } from "../../../../../utils/generateCodeUtm";
import Swal from "sweetalert2";
import { UploadButton } from "../../../../../components/UploadButton/UploadButton";
import FullScreenLoader from "../../../../../components/FullScreenLoader/FullScreenLoader";
import { validarSenhaSegura } from "../../../../../utils/ValidatePassword";
import "./styles.css";

function ModalNovoUsuario({
  isOpen,
  onClose,
  usuarioSelecionado = null,
  isReadonly,
}) {
  const CONFIG_TAXAS = {
    porcentagemGoogle: 0,
    taxaPlataforma: 0,
    porcentagem: 5,
    idAfiliado: ""
  } 

  const { userData, exibirLogs } = useContext(Context);
  const tipoContaUserLogado = userData?.tipoConta || "Desconhecido";

  const [nome, setNome] = useState("");
  const [porcentagem, setPorcentagem] = useState(10);
  const [taxaPlataforma, setTaxaPlataforma] = useState(0);
  const [porcentagemDivisao, setPorcentagemDivisao] = useState(0);
  const [linkGrupo, setLinkGrupo] = useState("");
  const [apelido, setApelido] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [telefone, setTelefone] = useState("");
  const [estado, setEstado] = useState("");
  const [cidade, setCidade] = useState("");
  const [cidades, setCidades] = useState([]);
  const [chavesPix, setChavesPix] = useState([]);
  const [utm, setUtm] = useState("");
  const [hideForm, setHideForm] = useState(false);
  const [tipoConta, setTipoConta] = useState("usuario");
  const [utmSalva, setUtmSalva] = useState("");
  const [minhasUtms, setMinhasUtms] = useState([]);
  const [novaUtm, setNovaUtm] = useState("");
  const [perfil, setPerfil] = useState("");
  const [rgFrente, setRgFrente] = useState(null);
  const [rgVerso, setRgVerso] = useState(null);
  const [loading, setLoading] = useState(false);
  const { valido, htmlFeedback } = validarSenhaSegura(password);
  const [openAccordion, setOpenAccordion] = useState('');
  const [membros, setMembros] = useState("");
  const [selectedMembros, setSelectedMembros] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);


  const [afiliadoInfo, setAfiliadoInfo] = useState({
    porcentagemGoogle: CONFIG_TAXAS.porcentagemGoogle,
    taxaPlataforma: CONFIG_TAXAS.taxaPlataforma,
    porcentagem: CONFIG_TAXAS.porcentagem,
    idAfiliado: CONFIG_TAXAS.idAfiliado,
  });

  const fetchMembros = async (idAfiliado) => {
    try {
      const response = await api.post(`/auth/user/afiliadoRef`, { 
        afiliadoRef: usuarioSelecionado.afiliadoConfig.idAfiliado 
      });
      
      setSelectedMembros(response.data.data || []);
      
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar membros do afiliado:", error);
      setSelectedMembros([]);
    }
  }

  useEffect(() => {
    if (usuarioSelecionado) {
      fetchMembros(usuarioSelecionado.idAfiliado);
    }
  }, [usuarioSelecionado]);

  const toggleAccordion = (id) => {
    if (openAccordion === id) {
      setOpenAccordion('');
    } else {
      setOpenAccordion(id);
    }
  };

  const handleAfiliadoChange = (e) => {
  const { id, value } = e.target;
  setAfiliadoInfo((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(() => {
    if (estado) {
      const estadoSelecionado = EstadosECidades.estados.find(
        (e) => e.sigla === estado
      );
      if (estadoSelecionado) {
        setCidades(estadoSelecionado.cidades);
        setCidade(estadoSelecionado.cidades[0]);
      }
    } else {
      setCidades([]);
      setCidade("");
    }
  }, [estado]);

  useEffect(() => {
    if (usuarioSelecionado) {
      setNome(usuarioSelecionado.nome || "");
      setApelido(usuarioSelecionado.apelido || "");
      setEmail(usuarioSelecionado.email || "");
      setCpfCnpj(formatCpfCnpj(usuarioSelecionado.cpfCnpj || ""));
      setTelefone(formatPhone(usuarioSelecionado.telefone || ""));
      setEstado(usuarioSelecionado.estado || "");
      setCidade(usuarioSelecionado.cidade || "");
      setPorcentagem(usuarioSelecionado.porcentagem || 10);
      setTaxaPlataforma(usuarioSelecionado.taxaPlataforma || 5);
      setPorcentagemDivisao(usuarioSelecionado.porcentagemDivisao || 50);
      setLinkGrupo(usuarioSelecionado.linkGrupo || "");
      setChavesPix(usuarioSelecionado.chavesPix || []);
      setTipoConta(usuarioSelecionado.tipoConta || "usuario");
      setMinhasUtms(usuarioSelecionado.utms || []);
      setUtm(usuarioSelecionado.utmCampaign || "");
      setPassword("");
      setRgFrente(
        usuarioSelecionado.documentoFrente
          ? usuarioSelecionado.documentoFrente
          : ""
      );
      setRgVerso(
        usuarioSelecionado.documentoVerso
          ? usuarioSelecionado.documentoVerso
          : ""
      );

      if (usuarioSelecionado.afiliadoConfig) {
        setAfiliadoInfo({
            porcentagemGoogle: usuarioSelecionado.afiliadoConfig.porcentagemGoogle || CONFIG_TAXAS.porcentagemGoogle,
            taxaPlataforma: usuarioSelecionado.afiliadoConfig.taxaPlataforma || CONFIG_TAXAS.taxaPlataforma,
            porcentagem: usuarioSelecionado.afiliadoConfig.porcentagem || CONFIG_TAXAS.porcentagem,
            idAfiliado: usuarioSelecionado.afiliadoConfig.idAfiliado || CONFIG_TAXAS.idAfiliado,
        });
      }
    } else {
      setNome("");
      setApelido("");
      setEmail("");
      setCpfCnpj("");
      setTelefone("");
      setEstado("");
      setCidade("");
      setPorcentagem(10);
      setTaxaPlataforma(5);
      setPorcentagemDivisao(50);
      setLinkGrupo("");
      setChavesPix([]);
      setTipoConta("usuario");
      setMinhasUtms([]);
      setUtm("");
      setPassword("");
      setRgFrente("");
      setRgVerso("");
      setMembros("")
      setSelectedMembros([])
      setSearchResults([])
    }
    setHideForm(false);
    setUtmSalva("");
    setNovaUtm("");
  }, [usuarioSelecionado, isOpen]);

  async function handleSubmit() {
    setLoading(true);

    if (chavesPix.length > 0 && !chavesPix.some(chave => chave.isPrincipal)) {
      setLoading(false);
      Swal.fire({
        title: "Atenção!",
        text: "Se você adicionar uma ou mais chaves Pix, é obrigatório definir uma como principal.",
        icon: "warning",
      });
      return;
    }

    if (password) {
      setLoading(false);
      if (!valido) {
        Swal.fire({
          title: "Senha fraca!",
          html: htmlFeedback,
          icon: "error",
        });

        throw new Error("Modal de cadastro usuario no painel: Senha fraca!");
      }
    }

    if (
      !telefone &&
      (tipoConta === "usuario" || tipoConta === "influenciador")
    ) {
      setLoading(false);
      Swal.fire({
        title: "Não foi possivel adicionar este usuario!",
        text: "Por favor, preencha um telefone",
        icon: "error",
      });

      throw new Error(
        "Modal de cadastro usuario no painel: Por favor, preencha um telefone!"
      );
    }

    const uidsDosMembros = selectedMembros.map(user => user.uid);

    const novoUsuario = {
      nome,
      apelido,
      email,
      password: password || password != "" ? password : undefined,
      cpfCnpj: limparCpfCnpj(cpfCnpj),
      telefone: limparTelefone(telefone),
      estado,
      cidade,
      porcentagem,
      taxaPlataforma,
      chavesPix,
      porcentagemDivisao,
      linkGrupo,
      status: "ativo",
      statusAprovacao: "Aprovado",
      utmCampaign: utm.trim() !== "" ? utm : undefined,
      tipoConta,
      utms: minhasUtms,
      afiliadoConfig: afiliadoInfo,
      membros: uidsDosMembros
    };

    if (!usuarioSelecionado) {
      novoUsuario.password = password;
      novoUsuario.status = "ativo";
      novoUsuario.statusAprovacao = "Aprovado";
    }

    try {
      if (usuarioSelecionado) {
        await api.put(
          `/admin/user/update/${usuarioSelecionado.uid}`,
          novoUsuario
        );
        toast.success("Usuário atualizado com sucesso!");

        if (rgFrente || rgVerso) {
          const formData = new FormData();
          formData.append("frente", rgFrente);
          formData.append("verso", rgVerso);

          try {
            await api.patch(
              `/auth/upload-docs/${usuarioSelecionado._id}`,
              formData,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            );
          } catch (error) {
            exibirLogs && console.error("Erro ao enviar documentos:", error);
            toast.error(error.response.data.error);
            throw new Error(
              "Modal de cadastro usuario no painel: " +
                error.response.data.error ||
                "Erro desconhecido ao enviar documentos"
            );
          }
        }
        onClose();
      } else {
        try {
          const response = await api.post("/admin/users/create", novoUsuario);
          setUtmSalva(response.data?.data.codeUtm);
          exibirLogs && console.log(response.data);

          if (rgFrente || rgVerso) {
            const idUser = response.data?.data._id;
            const formData = new FormData();
            formData.append("frente", rgFrente);
            formData.append("verso", rgVerso);

            try {
              await api.patch(`/auth/upload-docs/${idUser}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
              });
            } catch (err) {
              exibirLogs && console.error("Erro ao enviar documentos:", err);
              throw new Error(
                "Modal de cadastro usuario no painel: " +
                  err.response.data.error ||
                  "Erro desconhecido ao enviar documentos"
              );
            }
          }
          setHideForm(true);
        } catch (error) {
          exibirLogs && console.error(error);
          toast.error(error.response.data.error);
          throw new Error(
            "Modal de cadastro usuario no painel: " +
              error.response.data.error || "Erro desconhecido ao criar usuário"
          );
        }
      }
    } catch (error) {
      exibirLogs &&
        console.error(
          "Erro ao cadastrar usuário:",
          error.response?.data || error
        );
      toast.error(error.response?.data.error);
      throw new Error(
        "Modal de cadastro usuario no painel: " + error.response?.data ||
          "Erro desconhecido ao cadastrar usuário"
      );
    } finally {
      setLoading(false);
    }
  }

  const deleteUser = async () => {
    if (usuarioSelecionado) {
      console.log(usuarioSelecionado);
      const confirm = await Swal.fire({
        title: "Tem certeza?",
        text: "Esta ação não pode ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, excluir",
        cancelButtonText: "Cancelar",
      });

      if (confirm.isConfirmed) {
        try {
          await api.delete(`/admin/delete-user/${usuarioSelecionado.uid}`);
          toast.success("Usuário excluído com sucesso!");
          onClose();
        } catch (error) {
          exibirLogs && console.error("Erro ao excluir usuário:", error);
          toast.error(
            error.response?.data || "Erro desconhecido ao excluir usuário"
          );
          throw new Error(
            "Modal ao excluir usuario no painel: " + error.response?.data ||
              "Erro desconhecido ao excluir usuário"
          );
        }
      }
    }

    return null;
  };

  const fetchUsers = useCallback(async (searchQuery) => {
    if (searchQuery.length < 3) {
      setSearchResults([]);
      return;
    }

    setSearchLoading(true);
    try {
      const response = await api.get("/admin/users", {
        params: {
          search: searchQuery,
          limit: 10,
        },
      });

      const fetchedUsers = response.data.data || [];
  
      const availableUsers = fetchedUsers.filter(
        (user) => !selectedMembros.some((selected) => selected.uid === user.uid)
      );

      setSearchResults(availableUsers || []);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar usuários:", error);
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (membros.length >= 3) {
        fetchUsers(membros);
      } else {
        setSearchResults([]);
      }
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [membros, fetchUsers]);

  const handleSearchChange = (e) => {
    setMembros(e.target.value);
   };

   const handleUserSelect = (userToAdd) => {
      if (userToAdd.afiliadoRef) {
        Swal.fire({
          title: "Ação não permitida",
          text: `O usuário ${userToAdd.nome} já é membro de outro afiliado.`,
          icon: "warning",
        });
        return; 
      }

      if (!selectedMembros.some((member) => member.uid === userToAdd.uid)) {
        setSelectedMembros([...selectedMembros, userToAdd]);
      }
      setMembros(""); 
      setSearchResults([]);
    };

  const handleRemoveUser = (uidToRemove) => {
    setSelectedMembros(
      selectedMembros.filter((member) => member.uid !== uidToRemove)
    );
  };
  

  const clearForm = () => {
    setNome("");
    setApelido("");
    setEmail("");
    setPassword("");
    setCpfCnpj("");
    setTelefone("");
    setEstado("");
    setCidade("");
    setPorcentagem(10);
    setPorcentagemDivisao(50);
    setLinkGrupo("");
    setCidades([]);
    setUtm("");
    setTipoConta("usuario");
    setHideForm(false);
    setMinhasUtms([]);
    setNovaUtm("");
    setAfiliadoInfo({
      porcentagemGoogle: 0,
      taxaPlataforma: 0,
      porcentagem: 5,
      idAfiliado: "",
    });
  };

  const handleCopy = () => {
    const loginData = `Usuário: ${email}\nSenha: ${password}\nLink de acesso: ${Config.URL_DASH}`;
    copyToClipboard(loginData);
    toast.success("Dados copiados!");
    onClose();
    clearForm();
  };

  const addUtm = () => {
    if (!perfil) {
      Swal.fire({
        title: "Operação inválida",
        text: "O perfil deve ser preenchido",
        icon: "warning",
      });
      return;
    }
    const utmLimpa = novaUtm ? novaUtm.trim() : generateCodeUtm();
    if (utmLimpa && !minhasUtms.includes(utmLimpa)) {
      setMinhasUtms((prev) => [...prev, { utm: utmLimpa, perfil }]);
      setNovaUtm("");
      setPerfil("");
    }
  };

  const removeUtm = (index) => {
    setMinhasUtms((prev) => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    if (!isOpen) {
      clearForm();
    }
  }, [isOpen]);

  const handleChavePixChange = (index, field, value) => {
    const novasChaves = [...chavesPix];
    novasChaves[index][field] = value;
    setChavesPix(novasChaves);
  };

  const addChavePix = () => {
    setChavesPix([
      ...chavesPix,
      { tipo: "email", chave: "", isPrincipal: false },
    ]);
  };

  const removeChavePix = (index) => {
    setChavesPix(chavesPix.filter((_, i) => i !== index));
  };

  const handlePrincipalChange = (selectedIndex) => {
    const isChecking = !chavesPix[selectedIndex].isPrincipal;

    const novasChaves = chavesPix.map((chave, index) => {
      return {
        ...chave,
        isPrincipal: index === selectedIndex ? isChecking : false,
      };
    });

    setChavesPix(novasChaves);
  };

  const onTipoContaChange = (value) => {
    setTipoConta(value);
    if (value === "influenciador" ) {
      setTaxaPlataforma(0);
      setPorcentagem(10);
      setPorcentagemDivisao(50);
    }

    if (value === "usuario") {
      setTaxaPlataforma(10);
      setPorcentagem(10); // Taxa google
      setPorcentagemDivisao(50)
    }

    if (value === "afiliado") {
      setTaxaPlataforma(0);
      setPorcentagem(0);
      setPorcentagemDivisao(5);
    }
  }

  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose} size="md" scrollable>
        <ModalHeader toggle={onClose}>
          Novo usuário{" "}
          {usuarioSelecionado?.codeUtm && (
            <>
              <p style={{ fontSize: 14 }}>
                codeUtm principal: {usuarioSelecionado?.codeUtm}
              </p>
            </>
          )}
        </ModalHeader>
        <ModalBody>
          {loading && <FullScreenLoader />}
          {hideForm ? (
            <>
              <h5>Dados de login:</h5>
              <p>
                <strong>Usuário:</strong> {email}
              </p>
              <p>
                <strong>Senha:</strong> {password}
              </p>
              <p>
                <strong>Acesso ao dashboard:</strong> {Config.URL_DASH}
              </p>
              <Button color="primary" onClick={handleCopy}>
                Copiar
              </Button>
            </>
          ) : (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="nomeCompleto">Nome completo</Label>
                    <Input
                      id="nomeCompleto"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="apelido">Apelido</Label>
                    <Input
                      id="apelido"
                      value={apelido}
                      onChange={(e) => setApelido(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="email">E-mail</Label>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="senha">Crie uma senha segura</Label>
                    <Input
                      id="senha"
                      type="text"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="cpfCnpj">CPF/CNPJ (Opcional)</Label>
                    <Input
                      id="cpfCnpj"
                      value={cpfCnpj}
                      onChange={(e) =>
                        setCpfCnpj(formatCpfCnpj(e.target.value))
                      }
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="telefone">Telefone</Label>
                    <Input
                      id="telefone"
                      value={telefone}
                      onChange={(e) => setTelefone(formatPhone(e.target.value))}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="tipoConta">Tipo de Conta</Label>
                    <Input
                      id="tipoConta"
                      type="select"
                      value={tipoConta}
                      onChange={(e) => onTipoContaChange(e.target.value)}
                      disabled={isReadonly}
                    >
                      <option value="usuario">Cortador</option>
                      <option value="influenciador">Influenciador</option>
                      <option value="automacao">Automação</option>
                      <option value="gestor">Gestor</option>
                      {tipoContaUserLogado === "administrador" && (
                        <>
                          <option value="administrador">Admin</option>
                        </>
                      )}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="estado">Estado</Label>
                    <Input
                      id="estado"
                      type="select"
                      value={estado}
                      onChange={(e) => setEstado(e.target.value)}
                      disabled={isReadonly}
                    >
                      <option value="">Selecione</option>
                      {EstadosECidades.estados.map((estado) => (
                        <option key={estado.sigla} value={estado.sigla}>
                          {estado.nome}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="cidade">Cidade</Label>
                    <Input
                      id="cidade"
                      type="select"
                      value={cidade}
                      onChange={(e) => setCidade(e.target.value)}
                      disabled={isReadonly}
                    >
                      {cidades.map((cidade) => (
                        <option key={cidade} value={cidade}>
                          {cidade}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="linkGrupo">Link do Grupo</Label>
                    <Input
                      id="linkGrupo"
                      type="text"
                      value={linkGrupo}
                      onChange={(e) => setLinkGrupo(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>

                <h5 style={{textAlign: "center", marginBottom: 15}}>Taxas</h5>
                <hr />
                <Col md={6}>
                  <FormGroup>
                    <Label for="porcentagem">Taxa google</Label>
                    <Input
                      id="porcentagem"
                      type="number"
                      value={porcentagem}
                      onChange={(e) => setPorcentagem(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="porcentagem">Taxa da plataforma</Label>
                    <Input
                      id="taxaPlataforma"
                      type="number"
                      value={taxaPlataforma}
                      onChange={(e) => setTaxaPlataforma(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>

                <Col md={12}>
                  <FormGroup>
                    <Label for="porcentagem">Porcentagem de divisão</Label>
                    <Input
                      id="porcentagemDivisao"
                      type="number"
                      value={porcentagemDivisao}
                      onChange={(e) => setPorcentagemDivisao(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>

                <hr />

                <Col md={12}>
                  <Label for="chavePix">Chaves Pix</Label>
                  {chavesPix.length > 0
                    ? chavesPix.map((chave, index) => (
                        <Row
                          key={index}
                          className="mb-2"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Col md={4}>
                            <FormGroup>
                              {index === 0 && (
                                <Label for={`tipo-pix-${index}`}>Tipo</Label>
                              )}
                              <Input
                                id={`tipo-pix-${index}`}
                                type="select"
                                value={chave.tipo}
                                onChange={(e) =>
                                  handleChavePixChange(
                                    index,
                                    "tipo",
                                    e.target.value
                                  )
                                }
                                disabled={isReadonly}
                              >
                                <option value="cpf">CPF</option>
                                <option value="cnpj">CNPJ</option>
                                <option value="telefone">Telefone</option>
                                <option value="email">E-mail</option>
                                <option value="aleatoria">Aleatória</option>
                                <option value="copiaCola">Copia e cola</option>
                              </Input>
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              {index === 0 && (
                                <Label for={`chave-pix-${index}`}>Chave</Label>
                              )}
                              <Input
                                id={`chave-pix-${index}`}
                                type="text"
                                value={chave.chave}
                                placeholder="Insira a chave pix"
                                onChange={(e) =>
                                  handleChavePixChange(
                                    index,
                                    "chave",
                                    e.target.value
                                  )
                                }
                                readOnly={isReadonly}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2}>
                            <FormGroup>
                              {index === 0 && (
                                <Label for={`chave-pix-check-${index}`}>
                                  Principal
                                </Label>
                              )}
                              <br />
                              <Input
                                id={`chave-pix-check-${index}`}
                                type="checkbox"
                                checked={chave.isPrincipal}
                                placeholder="Insira a chave pix"
                                onChange={() => handlePrincipalChange(index)}
                                disabled={isReadonly}
                              />
                            </FormGroup>
                          </Col>

                          <Col md={2} className="d-flex align-items-end">
                            {!isReadonly && (
                              <Button
                                color="danger"
                                outline
                                onClick={() => removeChavePix(index)}
                              >
                                Remover
                              </Button>
                            )}
                          </Col>
                        </Row>
                      ))
                    : isReadonly && (
                        <Alert color="danger">
                          Nenhuma chave pix cadastrada.
                        </Alert>
                      )}
                  <br />
                  {!isReadonly && (
                    <Button
                      color="primary"
                      outline
                      onClick={addChavePix}
                      className="mb-3"
                    >
                      Adicionar Chave Pix
                    </Button>
                  )}
                </Col>

                {userData?.tipoConta !== "automacao" && (
                  <>
                    {tipoConta !== "administrador" &&
                      tipoConta !== "automacao" && (
                        <Col md={12} style={{ marginBottom: 20 }}>
                          <Label>Documento</Label>
                          <div className="upload-group">
                            <UploadButton
                              label="Frente"
                              type="file"
                              onFileChange={(file) => {
                                setRgFrente(file);
                              }}
                              file={rgFrente}
                              required
                              isDisabled={isReadonly}
                            />
                            <UploadButton
                              label="Verso"
                              onFileChange={(file) => {
                                setRgVerso(file);
                              }}
                              file={rgVerso}
                              required
                              isDisabled={isReadonly}
                            />
                          </div>
                        </Col>
                      )}
                  </>
                )}

                {/* Informações do afiliado aqui  */}
                <Accordion open={openAccordion} toggle={toggleAccordion} style={{ marginBottom: 10}}>
                  <AccordionItem>
                    <AccordionHeader targetId="1">
                      <b>Informações do Afiliado</b>
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="porcentagemGoogle">Porcentagem google</Label>
                            <Input
                              id="porcentagemGoogle"
                              type="text"
                              value={afiliadoInfo.porcentagemGoogle}
                              onChange={handleAfiliadoChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={6}>
                          <FormGroup>
                            <Label for="taxaPlataforma">Taxa da plataforma</Label>
                            <Input
                              id="taxaPlataforma"
                              type="text"
                              value={afiliadoInfo.taxaPlataforma}
                              onChange={handleAfiliadoChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={6}>
                          <FormGroup>
                            <Label for="porcentagem">Comissão (%)</Label>
                            <Input
                              id="porcentagem"
                              type="text"
                              value={afiliadoInfo.porcentagem}
                              onChange={handleAfiliadoChange}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={6}>
                          <FormGroup>
                            <Label for="idAfiliado">Id Afiliado</Label>
                            <Input
                              id="idAfiliado"
                              type="text"
                              value={afiliadoInfo.idAfiliado}
                              onChange={handleAfiliadoChange}
                              disabled
                            />
                          </FormGroup>
                        </Col>

                        <Col md={12}>
                            <FormGroup>
                              <Label for="membros">Membros</Label>
                              <Input
                                id="membros"
                                type="text"
                                name="membros"
                                value={membros}
                                onChange={handleSearchChange}
                                placeholder="Pesquisar por nome ou apelido..."
                                autoComplete="off"
                                readOnly={isReadonly}
                                style={{ marginTop: selectedMembros.length > 0 ? '10px' : '0' }}
                              />

                              {selectedMembros.length > 0 && 
                                <div className="tags-container">
                                  {selectedMembros.map((user) => (
                                    <div key={user.uid} className="user-tag">
                                      <span>
                                        {user.nome} {user.apelido ? `(${user.apelido})` : ""}
                                      </span>
                                      <Button
                                        close
                                        className="remove-tag-btn"
                                        onClick={() => handleRemoveUser(user.uid)}
                                      />
                                    </div>
                                  ))}
                                </div>
                              }
                            </FormGroup>

                            <ListGroup className="user-suggestions" style={{marginBottom: 0}}>
                              {searchResults.map((user) => (
                                <ListGroupItem
                                  key={user._id}
                                  tag="button"
                                  type="button"
                                  action
                                  onClick={() => handleUserSelect(user)}
                                  className=""
                                >
                                  {user.nome}{" "} {user.apelido && `(${user.apelido})`}
                                </ListGroupItem>
                              ))}
                            </ListGroup>
                        </Col>
                      </Row>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
                <hr />

                {tipoConta !== "administrador" && tipoConta !== "automacao" && (
                  <>
                    <strong>Cadastre uma utm</strong>
                    <Col md={6} style={{ marginTop: 5 }}>
                      <FormGroup>
                        <Label for="novaUtm">
                          Utm
                          <small className="text-muted"> (opcional)</small>
                        </Label>
                        <div className="d-flex gap-2">
                          <Input
                            id="novaUtm"
                            value={novaUtm}
                            onChange={(e) => setNovaUtm(e.target.value)}
                            readOnly={isReadonly}
                          />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="novaUtm">Perfil</Label>
                        <div className="d-flex gap-2">
                          <Input
                            id="novoPerfil"
                            value={perfil}
                            onChange={(e) => setPerfil(e.target.value)}
                            readOnly={isReadonly}
                          />
                          {userData?.tipoConta !== "financeiro" && (
                            <Button color="success" onClick={addUtm}>
                              Adicionar
                            </Button>
                          )}
                        </div>
                      </FormGroup>
                    </Col>

                    <Col md={12}>
                      {minhasUtms.length > 0 && (
                        <div className="mt-2">
                          <hr />
                          <strong>Meus links</strong>
                          {minhasUtms.map((utm, index) => (
                            <>
                              <Row
                                key={index}
                                className="align-items-center mb-2"
                              >
                                <Col xs={12} md={5}>
                                  <div style={{ maxWidth: "100%" }}>
                                    <b>Utm:</b> {utm.utm}
                                  </div>
                                </Col>
                                <Col xs={12} md={4}>
                                  <div style={{ maxWidth: "100%" }}>
                                    <b>Perfil:</b> {utm.perfil}
                                  </div>
                                </Col>
                                <Col xs={12} md={3} className="mt-2 mt-md-0">
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => removeUtm(index)}
                                    className="w-100 w-md-auto"
                                    disabled={isReadonly}
                                  >
                                    Remover
                                  </Button>
                                </Col>
                              </Row>
                              <br />
                            </>
                          ))}
                        </div>
                      )}
                    </Col>
                  </>
                )}
              </Row>
            </Form>
          )}
        </ModalBody>
        {!hideForm && userData?.tipoConta !== "financeiro" && (
          <ModalFooter>
            {usuarioSelecionado ? (
              <>
                <Button color="danger" onClick={deleteUser}>
                  Excluir
                </Button>
                <Button color="primary" onClick={handleSubmit}>
                  Salvar
                </Button>
              </>
            ) : (
              <Button color="primary" onClick={handleSubmit}>
                Cadastrar conta
              </Button>
            )}
          </ModalFooter>
        )}
      </Modal>
    </>
  );
}

export default ModalNovoUsuario;
